var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card border-0 dash-card micro-card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card__value"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"card__title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }